import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-5" }
const _hoisted_2 = { class: "bg-carte" }
const _hoisted_3 = { class: "s11_mobile px-8 pt-5 pb-4" }
const _hoisted_4 = { class: "flex align-items-center gap-3" }
const _hoisted_5 = { class: "secondary-font text-8xl" }
const _hoisted_6 = { class: "flex gap-5 mt-2" }
const _hoisted_7 = {
  class: "btn-supra lg flex-center flex-col align-items-center opacity-3",
  disabled: ""
}
const _hoisted_8 = { class: "text-grey-700" }
const _hoisted_9 = {
  key: 0,
  class: "s9_mobile"
}
const _hoisted_10 = { class: "card-carte-light" }
const _hoisted_11 = { class: "card-carte-floating right-bottom" }
const _hoisted_12 = { class: "secondary-font font-bold" }
const _hoisted_13 = { class: "flex align-items-center gap-2" }
const _hoisted_14 = { class: "secondary-font text-5xl" }
const _hoisted_15 = { class: "secondary-font font-bold mt-2" }
const _hoisted_16 = {
  key: 1,
  class: "s9_mobile"
}
const _hoisted_17 = {
  key: 0,
  class: "flex-center gap-3 mt-4"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "s11_mobile flex-center gap-5" }
const _hoisted_21 = { class: "w-35 px-1" }
const _hoisted_22 = { class: "w-65" }
const _hoisted_23 = { class: "secondary-font font-semibold text-grey-700 mb-2" }
const _hoisted_24 = { class: "secondary-font font-semibold text-grey-800 mb-2" }
const _hoisted_25 = { class: "s9_mobile" }
const _hoisted_26 = {
  class: "h-20 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_27 = { class: "widget-floating px-5 py-0 flex-left" }
const _hoisted_28 = { class: "w-50 text-sm" }
const _hoisted_29 = { class: "w-50 text-sm text-right font-bold" }
const _hoisted_30 = {
  key: 2,
  class: "s20 flex gap-3 mb-6"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 3,
  class: "s20"
}
const _hoisted_33 = { class: "s13 mt-2" }
const _hoisted_34 = { class: "secondary-font font-semibold mb-1" }
const _hoisted_35 = { class: "secondary-font font-semibold text-sm text-grey-600 mb-2" }
const _hoisted_36 = {
  key: 0,
  class: "text-grey-600 mb-4"
}
const _hoisted_37 = {
  key: 4,
  class: "flex-center py-7"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Doughnut = _resolveComponent("Doughnut")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "secondary-font font-bold mb-3" }, "Solde utilisable", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.selectedCarte ? (_ctx.showBalance ? _ctx.formatAmount(_ctx.selectedCarte.solde) : '*** ***') : '0'), 1),
          _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "secondary-font text-5xl mt-2" }, "F", -1)),
          _createElementVNode("div", {
            class: "mt-2 ml-2 cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showBalance = !_ctx.showBalance))
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("img", {
              src: "/public/icons/icon-eye-off.svg",
              class: "size-medium icon-black",
              alt: ""
            }, null, -1)
          ]))])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[4] || (_cache[4] = _createStaticVNode("<button class=\"btn-supra lg flex-center flex-col align-items-center opacity-3\" disabled data-v-37c339e8><div class=\"btn-supra-show-set btn-supra-animate mb-3\" data-v-37c339e8><div class=\"btn-supra-show px-2\" data-v-37c339e8><img src=\"/public/icons/icon-scan.svg\" class=\"btn-supra-icon icon-white\" alt=\"\" data-v-37c339e8></div></div><span class=\"text-grey-700\" data-v-37c339e8>Scanner</span></button><button class=\"btn-supra lg flex-center flex-col align-items-center opacity-3\" disabled data-v-37c339e8><div class=\"btn-supra-show-set btn-supra-animate mb-3\" data-v-37c339e8><div class=\"btn-supra-show px-2\" data-v-37c339e8><img src=\"/public/icons/icon-recharger.svg\" class=\"btn-supra-icon icon-white\" alt=\"\" data-v-37c339e8></div></div><span class=\"text-grey-700\" data-v-37c339e8>Recharger</span></button><button class=\"btn-supra lg flex-center flex-col align-items-center opacity-3\" disabled data-v-37c339e8><div class=\"btn-supra-show-set btn-supra-animate mb-3\" data-v-37c339e8><div class=\"btn-supra-show\" data-v-37c339e8><img src=\"/public/icons/icon-souscription.svg\" class=\"btn-supra-icon icon-white\" alt=\"\" data-v-37c339e8></div></div><span class=\"text-grey-700\" data-v-37c339e8>Répartition</span></button>", 3)),
          _createElementVNode("button", _hoisted_7, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "btn-supra-show-set btn-supra-animate mb-3" }, [
              _createElementVNode("div", { class: "btn-supra-show" }, [
                _createElementVNode("img", {
                  src: "/public/icons/icon-verrouillage.svg",
                  class: "btn-supra-icon icon-white",
                  alt: ""
                })
              ])
            ], -1)),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.selectedCarte?.statut === 'blocked' ? 'Verrouillée' : 'Verrouiller'), 1)
          ])
        ])
      ]),
      (_ctx.selectedCarte)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", null, [
                  _createElementVNode("h6", _hoisted_12, _toDisplayString(_ctx.selectedCarte.alias || _ctx.selectedCarte.type || 'Carte'), 1),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("h1", _hoisted_14, _toDisplayString(_ctx.showBalance ? _ctx.formatAmount(_ctx.selectedCarte.solde) : '***'), 1),
                    _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "secondary-font text-3xl" }, "F", -1))
                  ]),
                  _createElementVNode("h6", _hoisted_15, _toDisplayString(_ctx.selectedCarte.numeroMasque), 1)
                ])
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("img", {
                src: "/public/images/carte_coop.png",
                class: "card-carte-img",
                alt: "Carte"
              }, null, -1))
            ])
          ]))
        : (!_ctx.loading && _ctx.cartes.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[8] || (_cache[8] = [
              _createStaticVNode("<div class=\"card-carte-light\" style=\"opacity:0.3;\" data-v-37c339e8><div class=\"card-carte-floating right-bottom\" data-v-37c339e8><div data-v-37c339e8><h6 class=\"secondary-font font-bold\" data-v-37c339e8>Aucune carte</h6><p class=\"secondary-font text-sm\" data-v-37c339e8>Commandez votre première carte</p></div></div><img src=\"/public/images/carte_coop.png\" class=\"card-carte-img\" alt=\"\" data-v-37c339e8></div>", 1)
            ]))]))
          : _createCommentVNode("", true)
    ]),
    (_ctx.cartes.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cartes, (carte, idx) => {
            return (_openBlock(), _createElementBlock("span", {
              key: carte.id,
              class: _normalizeClass(["btn sm", _ctx.selectedCarteIndex === idx ? 'light2' : 'light']),
              onClick: ($event: any) => (_ctx.selectCarte(idx))
            }, _toDisplayString(carte.alias || carte.bloc4), 11, _hoisted_18))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _cache[13] || (_cache[13] = _createElementVNode("hr", { class: "hr mt-6 mb-6 opacity-1" }, null, -1)),
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "clear-both h-0" }, " ", -1)),
    (_ctx.selectedMois)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_Doughnut, {
                data: _ctx.doughnutData,
                options: _ctx.doughnutOptions
              }, null, 8, ["data", "options"])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _cache[9] || (_cache[9] = _createElementVNode("h4", { class: "secondary-font font-semibold text-grey-600 mb-2" }, "Solde utilisé", -1)),
              _createElementVNode("h2", _hoisted_23, _toDisplayString(_ctx.moisLabel(_ctx.selectedMois.mois)) + " " + _toDisplayString(_ctx.selectedMois.annee), 1),
              _createElementVNode("h1", _hoisted_24, _toDisplayString(_ctx.formatAmount(_ctx.soldeUtilise)) + " F CFA", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedMois.stat, (cat, idx) => {
              return (_openBlock(), _createElementBlock("div", { key: idx }, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.categorieLabel(cat.categorie_slug)) + "   " + _toDisplayString(Math.round(cat.pourcentage)) + "%", 1),
                    _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.formatAmount(cat.total)) + " F", 1)
                  ]),
                  _createElementVNode("div", {
                    class: "h-100p flex align-items-center justify-content-right rounded-100 text-lg text-white",
                    style: _normalizeStyle({ width: cat.pourcentage + '%', backgroundColor: _ctx.getCategorieColor(cat.categorie_slug) })
                  }, null, 4)
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "clear-both h-7" }, " ", -1))
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "clear-both h-20" }, " ", -1)),
    (_ctx.moisData.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moisData, (m, idx) => {
            return (_openBlock(), _createElementBlock("span", {
              key: idx,
              class: _normalizeClass(["btn sm cursor-pointer", _ctx.selectedMoisIndex === idx ? 'light2' : 'light']),
              onClick: ($event: any) => (_ctx.selectedMoisIndex = idx)
            }, _toDisplayString(_ctx.moisLabel(m.mois)), 11, _hoisted_31))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedMois)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedMois.transactions, (tx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: tx.id,
              class: "flex gap-6 mb-4"
            }, [
              _cache[11] || (_cache[11] = _createElementVNode("div", {
                class: "square-xl px-4 py-4",
                style: {"background-color":"rgba(0, 185, 172, 0.08)"}
              }, [
                _createElementVNode("img", {
                  src: "/public/icons/icon-trans-recharger.svg",
                  width: "100%",
                  class: "icon-neutral",
                  alt: ""
                })
              ], -1)),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("h6", _hoisted_34, _toDisplayString(tx.libelle), 1),
                _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.formatDateTransaction(tx.date)) + " - " + _toDisplayString(tx.reference), 1)
              ]),
              _createElementVNode("h5", {
                class: _normalizeClass(["s5 secondary-font text-right mt-2", tx.type === 'credit' ? 'text-green' : ''])
              }, _toDisplayString(tx.type === 'credit' ? '+' : '-') + _toDisplayString(_ctx.formatAmount(tx.montant)) + " F ", 3)
            ]))
          }), 128)),
          (_ctx.selectedMois.transactions.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, " Aucune transaction pour ce mois "))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [...(_cache[12] || (_cache[12] = [
          _createElementVNode("p", { class: "secondary-font text-grey-600" }, "Chargement...", -1)
        ]))]))
      : _createCommentVNode("", true),
    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "clear-both h-60" }, null, -1))
  ]))
}